import { JetpacB2BApi } from 'api' // NOTE: Assuming a B2B-specific API client exists. Please replace with the correct one.

export interface IWalletStatementBackendData {
  company_name: string
  company_id: string
  from_date?: string
  to_date?: string
}

class WalletStatementsApi {
  static async getWalletStatement(
    faberToken: string,
    searchTerm: IWalletStatementBackendData
  ) {
    // Build query parameters from the search term
    const queryParams = new URLSearchParams()

    // Add required parameters
    queryParams.append('company_name', searchTerm.company_name)
    queryParams.append('company_id', searchTerm.company_id)

    // Add optional parameters only if they exist
    if (searchTerm.from_date) {
      queryParams.append('from_date', searchTerm.from_date)
    }
    if (searchTerm.to_date) {
      queryParams.append('to_date', searchTerm.to_date)
    }

    // Construct the URL with query parameters
    const url = `wallet-ledger/statement?${queryParams.toString()}`

    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
}

export default WalletStatementsApi
